<div *ngIf="active" [ngClass]="'ui-widget-content ui-corner-all wizard-container'" [class]="styleClass">
  <ng-content></ng-content>
</div>